import React from 'react';

const WorkbookReadyPhase = ({term, workbookState, phase, onReady, onDone}) => {
  const wb = term.workbook;
  const isReady = workbookState.ready;

  return (
    <div className="lcv-work-panel">
      <div className="lcv-work-badge">
        <span className="lcv-work-dot" />
        WORKBOOK
      </div>

      <div className="lcv-work-exercise-label">
        <span className="lcv-work-page-icon">📖</span>
        <div>
          <div style={{fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: 0.5}}>Open your workbook to</div>
          <div className="lcv-work-page-number">{wb.exerciseLabel}</div>
        </div>
      </div>

      {!isReady && (
        <div style={{display: 'flex', justifyContent: 'center', marginTop: 8}}>
          <button className="lcv-btn-primary" onClick={onReady}>I'm Ready</button>
        </div>
      )}

      {isReady && (
        <>
          <div className="lcv-work-instruction">{wb.exercise}</div>
          <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            <button className="lcv-btn-primary" onClick={onDone}>I'm Done</button>
          </div>
        </>
      )}
    </div>
  );
};

export default WorkbookReadyPhase;
